import { CashTransactionsFacade, RevenueTransactionsFacade, SecurityTransactionsFacade, TransactionsFacade, TransactionTypeFacade } from 'src/app/store/transactions/facade/transactions.facade';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionsEffects } from 'src/app/store/transactions/effects/transactions.effects';
import { TransactionTypesReducer } from './reducers/transaction-types.reducer';
import { TransactionsReducers } from './reducers/transactions.reducer';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature('transactions', TransactionsReducers),
        StoreModule.forFeature('transactionTypes', TransactionTypesReducer),
        EffectsModule.forFeature([TransactionsEffects]),
        CommonModule
    ],
    providers: [
        TransactionsEffects,
        CashTransactionsFacade,
        SecurityTransactionsFacade,
        RevenueTransactionsFacade,
        TransactionTypeFacade
    ]
})

export class TransactionsStoreModule { }